import React from 'react';
import { Empty, Image } from 'antd';
import { CameraOutlined } from '@ant-design/icons';
import {
  ImageGalleryThumbStrip,
  SectionHeader,
  SideCard,
} from './HistoryDetail.styles';

const DevicePhotosCard = ({ images = [], activeImgIndex = 0, onImageSelect }) => (
  <SideCard>
    <SectionHeader $color="#8b5cf6">
      <div className="section-title">
        <div className="section-icon">
          <CameraOutlined />
        </div>
        <span>Device Photos ({images.length})</span>
      </div>
    </SectionHeader>

    {images.length > 0 ? (
      <Image.PreviewGroup
        items={images}
        preview={{ current: activeImgIndex || 0, onChange: onImageSelect }}
      >
        <div style={{ width: '100%', marginBottom: '14px' }}>
          <div
            style={{
              aspectRatio: '4/3',
              width: '100%',
              overflow: 'hidden',
              borderRadius: '14px',
              border: '1px solid #e2e8f0',
              background: '#f8fafc',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 14px rgba(15, 23, 42, 0.04)',
            }}
          >
            <Image
              width="100%"
              height="100%"
              src={images[activeImgIndex] || images[0]}
              style={{ objectFit: 'cover' }}
            />
          </div>
        </div>

        {images.length > 1 && (
          <ImageGalleryThumbStrip>
            {images.map((img, index) => (
              <div
                key={img || index}
                className="gallery-thumb"
                onClick={() => onImageSelect?.(index)}
                style={{
                  borderColor: activeImgIndex === index ? '#6366f1' : '#e2e8f0',
                  boxShadow: activeImgIndex === index ? '0 0 0 2px rgba(99, 102, 241, 0.25)' : 'none',
                }}
              >
                <img src={img} alt={`Device thumbnail ${index + 1}`} />
              </div>
            ))}
          </ImageGalleryThumbStrip>
        )}
      </Image.PreviewGroup>
    ) : (
      <div style={{ padding: '24px 0', textAlign: 'center' }}>
        <Empty description="No device inspection photos available" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </div>
    )}
  </SideCard>
);

export default DevicePhotosCard;
